var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    {
      staticClass: "app-header padding-y-md",
      staticStyle: {
        "background-color": "var(--white)",
        "--button-background": "transparent",
        "--button-hover-background": "transparent",
        "--button-margin-bottom": "0",
        "--button-padding": "var(--spacing-2xs) var(--spacing-md)",
        "--button-color": "var(--fa-md-gravy)",
        "--button-hover-color": "var(--fa-dk-blue)",
      },
      attrs: { id: "header" },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            staticClass:
              "wrap-app-header position-relative display-flex flex-items-center flex-content-between size-lg tablet:size-md",
          },
          [
            _vm._t("previous", function () {
              return [
                _vm.isShowingCancel
                  ? _c(
                      "a",
                      {
                        staticClass: "button flat",
                        attrs: {
                          href: "#",
                          "aria-label": "Let's go back",
                          "data-balloon-pos": "right",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.navigateBack()
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.$v7.solid.faArrowLeft,
                            size: "xl",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Let's go back"),
                        ]),
                      ],
                      1
                    )
                  : _c(
                      "site-link",
                      {
                        staticClass: "wrapper-logo-flag-animated button flat",
                        attrs: { to: { name: "home" } },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "main_navigation_link_click",
                              {
                                destination: "home",
                                context: "limited_main_navigation",
                              }
                            )
                          },
                        },
                      },
                      [
                        _c("wa-logo-flag"),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Font Awesome"),
                        ]),
                      ],
                      1
                    ),
              ]
            }),
            _vm._v(" "),
            _vm._t("title", function () {
              return [
                _c(
                  "h1",
                  {
                    staticClass:
                      "margin-y-0 margin-x-md laptop:margin-x-2xl size-md tablet:size-lg text-truncate",
                  },
                  [_vm._v(_vm._s(_vm.title))]
                ),
              ]
            }),
            _vm._v(" "),
            _vm._t("action", function () {
              return [
                _c(
                  "site-link",
                  {
                    staticClass: "button flat",
                    attrs: {
                      to: { name: "support" },
                      "aria-label": "Support",
                      "data-balloon-pos": "left",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture("support_link_click", {
                          context: "page_header_limited",
                        })
                      },
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: _vm.$v7.regular.faHeadset, size: "xl" },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr-only" }, [_vm._v("Support")]),
                  ],
                  1
                ),
              ]
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }